export default __webpack_public_path__ + "media/images/react_icons/xmark-7dbfa03a8b18fff00502854b7729a8e9.svg";